import { FC } from 'react';
import { CalculatorCurrencyField } from 'components/common';
import { CalculatorFormControl } from 'components/common/CalculatorFormControl';
import { useIntl } from 'react-intl';
import { SoleTraderFieldsQuestions } from './questions';
import { SoleTraderFieldsProps } from './types';

export const SoleTraderFields: FC<SoleTraderFieldsProps> = ({
  applicantNumber,
  incomeType,
  isTimeTradingMoreThanTwoYears,
}) => {
  const intl = useIntl();
  const { timeTrading, netTaxableIncomePreviousYear, netTaxableIncomeRecentYear, error } = SoleTraderFieldsQuestions;

  return (
    <>
      <CalculatorFormControl
        className={'xs:mb-5 md:mb-10'}
        name={`applicants[${applicantNumber}].${incomeType}.timeTrading`}
        titleKey={timeTrading.titleKey}
        textKey={timeTrading.textKey}
        radioOptions={timeTrading.options}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        isWide
      />
      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].${incomeType}.netTaxableIncomeRecentYear`}
        titleKey={netTaxableIncomeRecentYear.titleKey}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        className={'xs:mb-5 md:mb-10'}
      />
      {isTimeTradingMoreThanTwoYears && (
        <CalculatorCurrencyField
          name={`applicants[${applicantNumber}].${incomeType}.netTaxableIncomePreviousYear`}
          titleKey={netTaxableIncomePreviousYear.titleKey}
          rules={{ required: intl.formatMessage({ id: error.required }) }}
          className={'xs:mb-6 md:mb-12'}
        />
      )}
    </>
  );
};
